import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Logo from '../static/images/ss-original.png';
import { forgotPassword } from '../../Services/ApiCallsServices/AuthenticationApi';

const ForgotPassword = () => {
    const [username, setUsername] = useState(''); 
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        setError('');
        setMessage('');

        if (!username) {
            setError('Please enter your email address.');
            return;
        }

        try {
            await forgotPassword(username);
            setMessage('Password reset email sent. Please check your inbox.');
        } catch (error) {
            setError(error.message || 'Failed to send password reset email.');
        }
    };

    return (
        <>
            <Helmet>
                <title>Forgot Password | Storage Sprint</title>
            </Helmet>
            <div className="min-h-screen flex flex-col justify-between bg-white">
                <div className="flex flex-col items-center justify-center px-4 py-8">
                    <div className="w-full max-w-md mt-8 bg-white p-6 rounded-xl shadow-lg">
                        <div className="flex flex-col items-center text-center m-4">
                            <img
                                src={Logo}
                                alt="Storage Sprint Logo"
                                className="w-auto h-32 mb-4"
                            />
                            <h2 className="text-xl md:text-2xl font-bold text-yellow-600">
                                Reset Your Password
                            </h2>
                        </div>

                      

                        <p className="text-gray-700 text-sm mb-6">
                            Enter your email address associated with your account to reset your password.
                        </p>

                        <div className="space-y-4">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Email
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    value={username}
                                    placeholder="Enter your email"
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                />
                            </div>
                            {message && (
                            <p className="text-green-500 text-sm mb-4">{message}</p>
                            )}
                            {error && (
                                <div className="text-red-500 text-sm mb-4">{error}</div>
                            )}

                            <button
                                onClick={handleSubmit}
                                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
